import React, { useEffect, useState, useRef } from "react";
import {
  Grid,
  Box,
  Avatar,
  TextField,
  Link,
  IconButton,
  Button,
  Typography,
} from "@mui/material";
import Header from "../components/Header";
import MailIcon from "@mui/icons-material/Mail";
import axios from "axios";
import { API_URL } from "../components/Constant";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import Colors from "../components/Colors";
import TextfieldComponent from "../components/TextfeildComponent";
import Footer from "../components/Footer";

function ContactUS() {
  const [nickName, setNickName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  const [nickNameError, setNickNameError] = useState("");
  const [messageError, setMessageError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [termsDetails, setTermsDetails] = useState([]);

  const handleNickNameChange = (event) => {
    setNickName(event.target.value);
    setNickNameError("");
  };

  const handleLastNameChange = (event) => {
    setLastName(event.target.value);
  };

  const handlePhoneNoChange = (event) => {
    setPhoneNo(event.target.value);
    setPhoneError("");
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
    setMessageError("");
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setNickNameError("");
    setPhoneError("");
    setMessageError("");
    let isValid = true;
    if (!nickName) {
      setNickNameError("Nick name is required");
      isValid = false;
    }

    const phoneRegex = /^\d{10,12}$/;
    if (!phoneNo) {
      setPhoneNo("000");
    } else if (!phoneRegex.test(phoneNo)) {
      setPhoneError("Phone number must be 10 to 12 digits");
      isValid = false;
    }

    if (!message) {
      setMessageError("Message is required");
      isValid = false;
    }
    // else if (message.length > 250) {
    //   setMessageError('Message is too long.');
    //   isValid = false;
    // }

    if (isValid) {
      try {
        const Token = localStorage.getItem("PlayerTocken");
        const response = await axios.post(`${API_URL}/contact_form`, {
          nickName: nickName,
          phoneNo: phoneNo,
          message: message,
          token: Token,
        });

        if (response.status === 200) {
          setNickName("");
          setNickNameError("");
          setPhoneNo("");
          setPhoneError("");
          setMessage("");
          setMessageError("");
          setIsSuccessMessage(true);
        }
      } catch (error) {
        console.error("There was an error submitting the form:", error);
      }
    }
  };

  useEffect(() => {
    if (isSuccessMessage) {
      const timer = setTimeout(() => {
        setIsSuccessMessage(false);
      }, 8000); // 30 seconds
      return () => clearTimeout(timer);
    }
  }, [isSuccessMessage]);

  const handleKeyDownPhone = (event) => {
    const key = event.key;
    if (
      !/^\d$/.test(key) &&
      key !== "Backspace" &&
      key !== "Delete" &&
      key !== "ArrowLeft" &&
      key !== "ArrowRight"
    ) {
      event.preventDefault();
    }
  };

  const [isTermPopUp, setIsTermPopUp] = useState(false);

  const handleTermsAndCondtionClick = () => {
    setIsTermPopUp(true);
  };

  const handleCloseTerm = () => {
    setIsTermPopUp(false);
  };

  return (
    <Grid sx={{ width: "100%", height: "100%", padding: "0px", margin: "0px" }}>
      <Header></Header>

      <Box
        sx={{
          width: "100%",
          height: { xs: "95%", md: "97.5%" },
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          paddingTop: { xs: "5%", md: "2.5%" },
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "16px", md: "28px" },
            fontWeight: 600,
            fontFamily: "Boogaloo",
            lineHeight: { xs: "24px", md: "36px" },
            color: "#000",
          }}
        >
          Contact us
        </Typography>
        <Box
          sx={{
            width: "100%",
            height: "95%",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            maxWidth: "92.5%",
            gap: "20px",
            paddingBottom: "5%",
          }}
        >
          <Typography
            component="h3"
            sx={{
              fontSize: { xs: "24px", md: "24px" },
              fontWeight: 600,
              lineHeight: { xs: "30px", md: "28px" },
              color: Colors.signupBorder,
            }}
          >
            We're Here for You
          </Typography>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              justifyContent: "center",
              alignItems: "left",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <Typography component="h4" sx={{ lineHeight: "24px" }}>
              Thank you for playing our puzzle game! We value your feedback,
              questions, and suggestions. Please use the form below to share
              your thoughts or let us know if you encounter any issues. If you
              prefer, you can contact us directly via email. We're dedicated to
              ensuring your gaming experience is fun and smooth, and we
              appreciate your input as we continue to improve the game. We look
              forward to hearing from you!
            </Typography>
          </Box>

          <Box
            sx={{
              width: "100%",
              height: "100%",
              justifyContent: "center",
              alignItems: "left",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Typography component="h5" sx={{ lineHeight: "24px" }}>
              If you have any questions or need assistance, feel free to contact
              us via email:
            </Typography>
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "left",
                cursor: "pointer",
                color: Colors.Tidesfont,
                fontSize: "16px",
              }}
            >
              <MailIcon sx={{ fontSize: "16px" }} />
              <a
                href="mailto:contact@brohandy.com"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  paddingLeft: "4px",
                }}
              >
                contact@snoword.com
              </a>
            </Typography>
          </Box>

          {!isSuccessMessage && (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                paddingTop: "5%",
                paddingBottom: "5%",
                borderRadius: "16px",
                borderRadius: "4px",
                background: Colors.Tidesbg,
              }}
            >
              <Box
                sx={{
                  width: "90%",
                  height: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                  border: "1px solid",
                  borderColor: Colors.signupBorder,
                  borderRadius: "16px",
                  background: Colors.signupboxbg,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "95%",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    maxWidth: { xs: "90%", md: "95%" },
                    flexDirection: "column",
                    gap: "8px",
                    paddingTop: { xs: "5%", md: "2.5%" },
                    paddingBottom: { xs: "5%", md: "2.5%" },
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "16px",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { md: "row", xs: "column" },
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "stretch",
                        gap: "16px",
                      }}
                    >
                      <Box
                        sx={{
                          gap: "10px",
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          flex: 1,
                        }}
                      >
                        <Typography sx={{ fontSize: "14px", color: "#fff" }}>
                          Nick name
                        </Typography>
                        <TextfieldComponent
                          value={nickName}
                          placeholder="Enter your Nick name"
                          error={!!nickNameError}
                          onChange={handleNickNameChange}
                        />
                        {nickNameError && (
                          <Typography
                            sx={{
                              color: "red",
                              fontFamily: "Roboto",
                              fontSize: { xs: "12px", md: "14px" },
                              fontWeight: 400,
                            }}
                          >
                            {nickNameError}
                          </Typography>
                        )}
                      </Box>
                      <Box
                        sx={{
                          gap: "10px",
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          flex: 1,
                        }}
                      >
                        <Typography sx={{ fontSize: "14px", color: "#fff" }}>
                          Phone number
                        </Typography>

                        <TextfieldComponent
                          value={phoneNo}
                          placeholder="Enter your phone number"
                          onChange={handlePhoneNoChange}
                          onKeyDown={handleKeyDownPhone}
                          inputProps={{ maxLength: 12 }}
                          error={!!phoneError}
                        />
                      </Box>
                    </Box>
                    {phoneError && (
                      <Typography
                        sx={{
                          color: "red",
                          fontFamily: "Roboto",
                          fontSize: { xs: "12px", md: "14px" },
                          fontWeight: 400,
                        }}
                      >
                        {phoneError}
                      </Typography>
                    )}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "16px",
                      }}
                    >
                      <Box
                        sx={{
                          gap: "10px",
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                        }}
                      >
                        <Typography sx={{ fontSize: "14px", color: "#fff" }}>
                          Message
                        </Typography>

                        <TextField
                          multiline
                          rows={3}
                          placeholder="Type your queries"
                          value={message}
                          onChange={handleMessageChange}
                          error={!!messageError}
                          sx={{
                            height: "84px",
                            width: "100%",
                            padding: "0px !important",
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                border: "1px solid",
                                borderColor: messageError
                                  ? "red"
                                  : Colors.signupBorder,
                                transition: "border-color 0.3s ease",
                              },
                              "&:hover fieldset": {
                                borderColor: messageError
                                  ? "red"
                                  : Colors.signupBorder,
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: messageError
                                  ? "red"
                                  : Colors.signupBorder,
                              },
                              "& .MuiInputBase-input::placeholder": {
                                fontFamily: "Roboto",
                                lineHeight: "16px",
                                fontSize: { xs: "12px", md: "14px" },
                                fontWeight: 400,
                                color: "#fff",
                                padding: {
                                  xs: "0px !important",
                                  md: "0px 0px !important",
                                },
                              },
                              "& .MuiInputBase-input": {
                                padding: {
                                  xs: "0px !important",
                                  md: "0px 0px !important",
                                },
                                fontSize: { xs: "12px", md: "14px" },
                                lineHeight: "18px",
                                fontFamily: "Roboto",
                                fontWeight: 400,
                                color: "#fff",
                              },
                              "&.css-dpjnhs-MuiInputBase-root-MuiOutlinedInput-root":
                                {
                                  padding: { xs: "8px 12px", md: "10px 16px" },
                                },
                            },
                          }}
                        />

                        {messageError && (
                          <Typography
                            sx={{
                              color: "red",
                              fontFamily: "Roboto",
                              fontSize: { xs: "12px", md: "14px" },
                              fontWeight: 400,
                            }}
                          >
                            {messageError}
                          </Typography>
                        )}
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "16px",
                        flexDirection: { xs: "column", md: "row" },
                      }}
                    >
                      {/* <Typography component="h6" sx={{ fontSize: '14px', textAlign: 'left', width: '100%' }}>
                    By clicking the submit button, you agree to our{' '}
                    <Link onClick={handleTermsAndCondtionClick} style={{ textDecoration: 'none', color: Colors.link, cursor:'pointer' }}>
                      Terms and conditions
                    </Link>.
                  </Typography> */}

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          width: "100%",
                        }}
                      >
                        <Button
                          onClick={handleFormSubmit}
                          type="submit"
                          sx={{
                            background: Colors.button2,
                            color: Colors.button2font,
                            width: "120px",
                            border: "1px solid ",
                            borderColor: Colors.button2Border,
                            borderRadius: "8px",
                            cursor: "pointer",
                            fontSize: "12px",
                            transition: "background 0.3s, transform 0.3s",
                            "&:hover": {
                              background: Colors.button2,
                              transform: "scale(1.05)",
                            },
                            "&:active": {
                              background: Colors.button2,
                            },
                          }}
                        >
                          Submit
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}

          {isSuccessMessage && (
            <Box
              sx={{
                width: "100%",
                height: "420px",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "row",
                gap: "8px",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: { xs: "180px", md: "74px", sm: "180px" },
                  display: "flex",
                  justifyContent: { xs: "center", md: "left" },
                  alignItems: "center",
                  flexDirection: { xs: "column", md: "row" },
                  gap: "8px",
                  background: Colors.Tidesbg,
                  borderRadius: "4px",
                  padding: { xs: "16px", md: "0px 16px" },
                }}
              >
                <CheckCircleIcon
                  style={{
                    color: "#0BEA14",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "50%",
                  }}
                />
                <Typography
                  component="h6"
                  sx={{
                    fontFamily: "Roboto",
                    fontWeight: 400,
                    fontSize: "14px",
                    color: "#000",
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  Your message has been sent successfully. We appreciate you
                  reaching out to us. Our team will get back to you as soon as
                  possible.
                </Typography>
              </Box>
            </Box>
          )}
        </Box>
      </Box>

      {/* {isTermPopUp && (
           <Box sx={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.6)',
            display: 'flex',alignItems: 'center',justifyContent: 'center',zIndex: '2',

        }}>
            <Box sx={{
                width: '100%', height: '100%', gap: '5px',
                justifyContent: 'center', alignItems: 'center', position: 'fixed',
                display: 'flex', flexDirection: 'column',
            }}>
                <Box sx={{
                    width: { md: '75%', sm: '75%', xs: '85%' }, height: '36px',
                    justifyContent: 'right', alignItems: 'right', display: 'flex',
                }}>
                     <IconButton onClick={handleCloseTerm} sx={{
                    position: 'fixed', width: '36px', height: '36px',}} >
                        <CloseOutlinedIcon sx={{ width: '36px', height: '36px', color: 'gray', '&:hover': {
                        width: '40px', height: '40px', color: 'gray', backgroundColor: 'none',
                        background:'none'},}} ></CloseOutlinedIcon>
                    </IconButton>
                </Box>
                <Box sx={{width: { md: '75%', sm: '75%', xs: '85%' },height: '90%', 
                        backgroundColor: Colors.white, border: '1px solid',
                        borderColor: Colors.white, borderRadius: '4px ',boxShadow: 'none',
                        zIndex: '3', alignItems: 'center', 
                    }}>

                 
                            <Box sx={{
                                display: 'flex', flexDirection: 'row', width: '100%', 
                                justifyContent: 'center', alignContent: 'center', height: '100%'}}>
                                    
                                    <Box sx={{
                                        display:  {xs: 'none', md:'flex' }, flexDirection: 'column', width: '50%', gap: '8px',
                                        justifyContent: 'center',  height: '100%', alignItems: 'center',
                                        backgroundImage: `url(${popupbg})`, backgroundRepeat: 'no-repeat',
                                        backgroundSize: '100% 100%',}}>
                                              <Box sx={{
                                                display: 'flex', flexDirection: 'column', width: '100%', gap: '12px',
                                                justifyContent: 'center', maxWidth:'75%',alignItems: 'left', }}>
                                                <Typography sx={{fontSize:'16px', color: Colors.white_80}}>Welcome</Typography>
                                                <Box sx={{
                                                display: 'flex', flexDirection: 'column',  width: '224px', height: '32px',
                                                justifyContent: 'center',alignItems: 'left', }}>
                                                <img src={whitelogo} alt="logo" style={{width: '100%', height: '100%', }}/>
                                                </Box>
                                                <Typography sx={{ color: Colors.white_80}}>Find the help you need, right in your neighborhood.</Typography>
                                             </Box>
                                    </Box>
                                    <Box sx={{
                                        display: 'flex', flexDirection: 'column', width: {xs: '100%', md:'50%' }, gap: '8px',
                                        justifyContent: 'flex-start',  height: '100%', alignItems: 'center',overflowX: 'auto',
                                        
                                        '&::-webkit-scrollbar': {
                                            width: '11px', height: '8px', borderRadius: '16px',
                                          },
                                          '&::-webkit-scrollbar-thumb': {
                                            backgroundColor: Colors.grey_30, borderRadius: '16px', border: '2px solid white',
                                          },
                                          '&::-webkit-scrollbar-track': {
                                            borderRadius: '16px', backgroundColor: Colors.white, 
                                          },}}>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '12px',                                           
                                            height:'100%', justifyContent: 'flex-start', maxWidth:'75%',alignItems: 'left',
                                            paddingTop:'5%',}}>
                                           <div dangerouslySetInnerHTML={{ __html:  termsDetails[0].content }} />
                                            </Box>
                                    </Box>
                            </Box>
                    
                </Box>
            </Box>
        </Box>)} */}

      <Footer />
    </Grid>
  );
}
export default ContactUS;
